export default "__VITE_ASSET__BYETbwLT__"